module.exports = __webpack_public_path__ + "static/media/hs-logo-ligg_h.0f16884f.png";